import React from 'react'
import { Typography, Box, Grid, Chip, Button } from '@mui/material'
import moment from 'moment'
import { STATUS_COLOR_MAP } from '../../../../../constant/status'

const Detail = ({ data }) => {
  return (
    <Box p={2}>
      <Grid container spacing={4} mb={4}>
        {/* General detail */}
        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>Status</Typography>
          <Box mt={1}>
            <Chip
              label={data.status}
              color={STATUS_COLOR_MAP[data.status]}
              size='small'
              style={{ fontWeight: 900 }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>Phone</Typography>
          <Typography variant='h6'>{data.phone}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>State</Typography>
          <Typography variant='h6'>{data.state}</Typography>
        </Grid>

        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>Keywords Number</Typography>
          <Typography variant='h6'>{data.keywords}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>Address</Typography>
          <Typography variant='h6'>{data.address}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>Mentioned VARTA?</Typography>
          <Typography variant='h6'>{data.mentionedVarta ?? 'N/A'}</Typography>
        </Grid>

        {/* Meta */}
        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>Created At</Typography>
          <Typography variant='h6'>
            {moment(data?.createdAt).format('YYYY-MM-DD h:mm a')}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>Last Update</Typography>
          <Typography variant='h6'>
            {moment(data?.updatedAt).format('YYYY-MM-DD h:mm a')}
          </Typography>
        </Grid>
      </Grid>
      {/* Message */}
      <Grid container spacing={4} mb={4}>
        <Grid item xs={12} sm={12} md={12}>
          <Typography variant='h4'>Reject Reason</Typography>
          <Box style={{ marginRight: '15%', marginLeft: '15%' }}>
            <Typography variant='h6'>{data.rejectReason ?? 'N/A'}</Typography>
          </Box>
        </Grid>
      </Grid>
      {/* Uploaded Images */}
      <Grid container spacing={4} mb={4}>
        <Grid item xs={12} sm={12} md={12}>
          <Typography variant='h2'>Workshop Photo: </Typography>
          <img src={`${data.workshopPhoto.uploadPath}`} height='auto' width='100%' alt={''} />
          <Button
            color='primary'
            href={`${data.workshopPhoto.uploadPath}`}
            target='_blank'
            rel='noopener noreferrer'
            sx={{ textTransform: 'none', textDecoration: 'underline' }}
          >
            Not showing? Click here.
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Detail
